module.exports = __webpack_public_path__ + "img/icon-lock.d63dfe3b.png";